import { Link } from "react-router";

/** Usable loading state with a retry control (docs/01 section 7). */
export function LoadingOverlay({
  stage,
  error,
  onRetry,
  hint,
}: {
  stage: string;
  error?: string | null;
  onRetry?: () => void;
  hint?: string;
}) {
  return (
    <div className="overlay" role={error ? "alert" : "status"} aria-live="polite">
      <div className="overlay-card">
        {error ? (
          <>
            <h2>Something needs a retry</h2>
            <p className="muted">{error}</p>
            <div className="row" style={{ justifyContent: "center" }}>
              {onRetry ? (
                <button type="button" className="btn btn-primary" onClick={onRetry}>
                  Retry
                </button>
              ) : null}
              <Link className="btn" to="/directory">
                Open the directory
              </Link>
            </div>
          </>
        ) : (
          <>
            <div className="spinner" aria-hidden="true" />
            <h2 style={{ fontSize: "1.05rem" }}>{stage}</h2>
            {hint ? <p className="muted small">{hint}</p> : null}
          </>
        )}
      </div>
    </div>
  );
}
